import { Injectable } from '@angular/core';
import { defineLocale, deLocale, esLocale, frLocale, zhCnLocale, jaLocale } from 'ngx-bootstrap/chronos';

@Injectable({
  providedIn: 'root',
})
export class LocaleService {
  constructor() {
    this.defineUsedLocales();
  }

  /**
   * Defines used locales in the application.
   * This is needed for using them in the datepicker.
   * See here: https://valor-software.com/ngx-bootstrap/#/datepicker#locales .
   */
  public defineUsedLocales(): void {
    defineLocale('de', deLocale);
    defineLocale('es', esLocale);
    defineLocale('fr', frLocale);
    defineLocale('cn', zhCnLocale);
    defineLocale('ja', jaLocale);
  }
}
